export const TIME_PRESETS = [
  { id: 'today', label: 'Today' },
  { id: '7d', label: '7d' },
  { id: '30d', label: '30d' },
  { id: '90d', label: '90d' },
  { id: 'all', label: 'All time' },
];

export function formatDateISO(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getPresetRange(presetId) {
  if (presetId === 'all') {
    return { start: 'ALL', end: 'ALL', preset: presetId };
  }

  const endDate = new Date();
  const startDate = new Date();
  if (presetId === 'today') {
    // same day
  } else if (presetId === '7d') {
    startDate.setDate(startDate.getDate() - 6);
  } else if (presetId === '30d') {
    startDate.setDate(startDate.getDate() - 29);
  } else if (presetId === '90d') {
    startDate.setDate(startDate.getDate() - 89);
  } else {
    startDate.setDate(startDate.getDate() - 89);
  }

  return {
    start: formatDateISO(startDate),
    end: formatDateISO(endDate),
    preset: presetId,
  };
}

export function formatDuration(seconds) {
  if (seconds == null || Number.isNaN(seconds)) {
    return '—';
  }
  const total = Math.max(0, Math.round(seconds));
  if (total < 60) {
    return `${total}s`;
  }
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  if (mins < 60) {
    return secs ? `${mins}m ${secs}s` : `${mins}m`;
  }
  const hours = Math.floor(mins / 60);
  const remMins = mins % 60;
  return remMins ? `${hours}h ${remMins}m` : `${hours}h`;
}

export function formatPercent(value) {
  return `${Number(value || 0).toFixed(1)}%`;
}

export function formatNumber(value) {
  return Number(value || 0).toLocaleString();
}

export function formatDisplayDateTime(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function userDisplayName(email) {
  if (!email) return 'unknown';
  const local = String(email).split('@')[0];
  return local || email;
}

export function translationTypeLabel(type) {
  switch ((type || '').toLowerCase()) {
    case 'exact':
      return 'Exact';
    case 'fuzzy-adapted':
    case 'fuzzy':
      return 'Fuzzy';
    case 'custom':
      return 'Custom';
    default:
      return type || '—';
  }
}
